module.exports = __webpack_public_path__ + "img/header.19bcc172.png";